// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const FAVORITE_USERS = "Moji obl\u00edben\u00ed";
export const HAVE_ME_AS_FAVORITE = "Maj\u00ed m\u011b mezi obl\u00edben\u00fdmi";
export const I_AM_MEMBER_OF_GROUPS = "Pat\u0159\u00edm do skupin";
export const MORE_ABOUT_ME_MY_PRODUCTS = "Pou\u017e\u00edv\u00e1m";
export const MORE_ABOUT_ME_MY_PRODUCTS_ADD_FIRST_PRODUCT = "P\u0159idej prvn\u00ed produkt";
export const MORE_ABOUT_ME_MY_PRODUCTS_SHOW = "Zobraz p\u0159idan\u00e9 produkty";
